@if (params.data.attributes?.has_restitution_agreement) {
  <app-pan-chip color="info" size="sm" fill="outline" matTooltip="This location has a restitution agreement.">
    <mat-icon class="mr-2">check</mat-icon> Restitution Agreement
  </app-pan-chip>
}

@if (params.data.attributes?.is_dining_location) {
  <app-pan-chip color="info" size="sm" fill="outline" matTooltip="This location is a dining location.">
    <mat-icon class="mr-2">check</mat-icon> Dining Location
  </app-pan-chip>
}

@if (params.data.attributes?.cellular_connection) {
  <app-pan-chip color="info" size="sm" fill="outline" matTooltip="This location has a limited bandwidth connection.">
    <mat-icon class="mr-2">check</mat-icon> Cellular Connection
  </app-pan-chip>
}
